import { render, staticRenderFns } from "./AppSectionComponent.vue?vue&type=template&id=186df0d1&scoped=true&"
import script from "./AppSectionComponent.ts?vue&type=script&lang=ts&"
export * from "./AppSectionComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppSectionComponent.scss?vue&type=style&index=0&id=186df0d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186df0d1",
  null
  
)

export default component.exports